module.exports = __webpack_public_path__ + "assets/icons/identify-sensor-touch.svg";